import { VideoPlayerConfig } from '@/interfaces/video';

export const VIDEO_THUMBNAIL_CONFIG = {
    thumbnailPath: '/images/garage.png',
    thumbnailWidth: 360,
    thumbnailHeight: 202,
};

export const BASE_VIDEO_CONFIG: Omit<VideoPlayerConfig, 'autoplay'> = {
    muted: true,
    controls: false,
    loop: true,
    preload: 'metadata',
    showTitle: false,
    showProgress: false,
    showVolume: false,
    showClose: false,
};
